import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

function Services() {
  const services = [
    {
      icon: '⚙️',
      title: 'Engine Diagnostics & Repair',
      value: 'engine-diagnostics',
      description: 'Expert troubleshooting and repair for all marine engine issues. From rough idle to complete failure, we diagnose and fix it.',
      details: [
        'Engine performance issues',
        'Starting problems',
        'Overheating diagnosis',
        'Fuel system repairs',
        'Complete engine overhauls'
      ]
    },
    {
      icon: '🔧',
      title: 'Routine Maintenance',
      value: 'routine-maintenance',
      description: 'Keep your boat running smoothly with regular maintenance services.',
      details: [
        'Oil changes',
        'Impeller replacement',
        'Spark plug replacement',
        'Fuel filter changes',
        'Engine tune-ups',
        'Winterization & de-winterization'
      ]
    },
    {
      icon: '⚡',
      title: 'Electrical & Battery Systems',
      value: 'electrical',
      description: 'Complete electrical diagnostics and battery system services to keep your electronics running.',
      details: [
        'Battery testing & replacement',
        'Charging system diagnosis',
        'Wiring repairs',
        'Electrical troubleshooting',
        'Circuit protection',
        'Marine electronics integration'
      ]
    },
    {
      icon: '💧',
      title: 'Bilge / Pumps / Plumbing',
      value: 'bilge-pumps',
      description: 'Keep water where it belongs with expert pump and plumbing services.',
      details: [
        'Bilge pump installation & repair',
        'Live well pump service',
        'Washdown pump systems',
        'Plumbing leak repairs',
        'Through-hull fitting service'
      ]
    },
    {
      icon: '🎛️',
      title: 'Steering & Controls',
      value: 'steering',
      description: 'Ensure safe and responsive boat handling with steering and control system services.',
      details: [
        'Steering cable replacement',
        'Hydraulic steering service',
        'Control cable adjustment',
        'Throttle & shift repairs',
        'Trim system service'
      ]
    },
    {
      icon: '🛡️',
      title: 'Pre-Trip Safety Checks',
      value: 'safety-check',
      description: 'Peace of mind before you hit the water with comprehensive safety inspections.',
      details: [
        'Full system inspection',
        'Safety equipment check',
        'Engine performance test',
        'Electrical system check',
        'Hull and propeller inspection',
        'Written safety report'
      ]
    },
    {
      icon: '🔩',
      title: 'Installations',
      value: 'installation',
      description: 'Professional installation of marine equipment and accessories.',
      details: [
        'Battery installation',
        'Battery charger installation',
        'Bilge pump installation',
        'Navigation lights',
        'Marine stereo systems',
        'Fish finders & GPS',
        'Accessories & upgrades'
      ]
    },
    {
      icon: '🔍',
      title: 'Custom Repairs',
      value: 'other',
      description: 'Don\'t see your issue listed? We handle a wide range of marine repairs and maintenance.',
      details: [
        'Custom fabrication',
        'Problem diagnosis',
        'Emergency repairs',
        'System upgrades',
        'Consultation services'
      ]
    }
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Professional mobile marine repair and maintenance, delivered to your dock or marina</p>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-details">
                  {service.details.map((detail, idx) => (
                    <li key={idx}>✓ {detail}</li>
                  ))}
                </ul>
                <Link to={`/booking?service=${service.value}`} className="btn btn-primary">Book This Service</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-darker">
        <div className="container">
          <div className="services-cta">
            <h2>Ready to Schedule Service?</h2>
            <p>Book online in 60 seconds or call for immediate assistance</p>
            <div className="cta-buttons">
              <Link to="/booking" className="btn btn-primary btn-large">Book Service Now</Link>
              <a href="tel:8503230769" className="btn btn-secondary btn-large">📞 850-323-0769</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
